export const METRO_CARD_NUMBER_PARSING_RULES = [
  {
    name: 'store',
    minLength: 2,
    maxLength: 3,
  },
  {
    name: 'customer',
    minLength: 4,
    maxLength: 8,
  },
  {
    name: 'cardholder',
    minLength: 2,
    maxLength: 2,
  },
  {
    name: 'service',
    minLength: 1,
    maxLength: 1,
  },
];
